import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api.js'

// Async thunks
export const fetchOrders = createAsyncThunk(
  'orders/fetchOrders',
  async (_, { rejectWithValue }) => {
    try {

      const response = await api.get(`/api/orders/`);
      return response.data;
    } catch (error) {
      // console.error('Fetch orders error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to fetch orders.');
    }
  }
);

export const addOrder = createAsyncThunk(
  'orders/addOrder',
  async (newOrder, { rejectWithValue }) => {
    try {

      const response = await api.post(`/api/orders/`, newOrder);
      return response.data;
    } catch (error) {
      // console.error('Add order error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to update order.');
    }
  }
);

export const deleteOrder = createAsyncThunk(
  'orders/deleteOrder',
  async (orderId, { rejectWithValue }) => {
    try {

      await api.delete(`/api/orders/${orderId}/`);
      return orderId;
    } catch (error) {
      // console.error('Delete order error response:', error.response);
      return rejectWithValue(error.response.data.message || 'Failed to delete order.');
    }
  }
);

export const updateOrder = createAsyncThunk(
  'orders/updateOrder',
  async ({ orderId, orderData }, { rejectWithValue }) => {
    try {

      const response = await api.patch(`/api/orders/${orderId}/`, orderData);
      return response.data;
    } catch (error) {
      //console.error('Update order error response:', error.response.data.detail);
      return rejectWithValue(error.response.data.message || 'Failed to update order.');
    }
  }
);

export const fetchOrdersByDate = createAsyncThunk(
  'orders/fetchOrdersByDate',
  async ({ day, month, year }, {rejectWithValue }) => {
    try {

      const config = {
        params: {
          day: day,
          month: month,
          year: year,
        },
      };
      const response = await api.get(`/api/orders/orders_by_date/`, config);
      return response.data;
    } catch (error) {
      // console.error('Fetch orders by date error response:', error.response);
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch orders by date.');
    }
  }
);
export const fetchOrdersByMonth = createAsyncThunk(
  'orders/fetchOrdersByMonth',
  async ({ month, year }, { rejectWithValue }) => {
    try {

      const config = {
        params: {
          month: month,
          year: year,
        },
      };
      const response = await api.get(`/api/orders/orders_by_month/`, config);
      return response.data;
    } catch (error) {
      // console.error('Fetch orders by date error response:', error.response);
      return rejectWithValue(error.response?.data?.detail || 'Failed to fetch orders by date.');
    }
  }
);

// Create Slice
const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    orders: [],
    ordersDetailsByDate: [],
    ordersDetailsByMonth: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrders.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrders.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload;
      })
      .addCase(fetchOrders.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch orders.';
      })
      .addCase(fetchOrdersByDate.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrdersByDate.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.ordersDetailsByDate = action.payload;
      })
      .addCase(fetchOrdersByDate.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch orders.';
      })
      .addCase(fetchOrdersByMonth.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrdersByMonth.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.orders = action.payload;
      })
      .addCase(fetchOrdersByMonth.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'Failed to fetch orders.';
      })
      .addCase(addOrder.fulfilled, (state, action) => {
        state.orders.push(action.payload);
      })
      .addCase(addOrder.rejected, (state, action) => {
        state.error = action.payload || 'Failed to add order.';
      })
      .addCase(deleteOrder.fulfilled, (state, action) => {
        state.orders = state.orders.filter(order => order.id !== action.payload);
      })
      .addCase(deleteOrder.rejected, (state, action) => {
        state.error = action.payload || 'Failed to delete order.';
      })
      .addCase(updateOrder.fulfilled, (state, action) => {
        const index = state.orders.findIndex(order => order.id === action.payload.id);
        if (index !== -1) {
          state.orders[index] = action.payload;
        }
      })
      .addCase(updateOrder.rejected, (state, action) => {
        state.error = action.payload || 'Failed to update order.';
      });
  }
});

export default orderSlice.reducer;